export default "__VITE_ASSET__r781rPC4__"